<template>

	<MainLayout>

		<v-container appwidth class="py-0">

			<v-row>
				<v-col cols="12" sm="12" md="8">
					<v-card>

						<VideoPlayer v-if="this.isVideoLesson" @change="onVideoChange" />

						<div v-if="this.$root.device.mobile" class="my-1">
							<div class="wrapper">
								<button class="accordion" @click="activetab = 1" :class="{ active: activetab === 1 }">
									<span v-if="this.isVideoLesson">{{ $t('lesson.tab.description') }}</span>
									<span v-else>{{ lessonCategory }}</span>
								</button>
								<div class="panel">
									<v-divider />
									<div class="content">
										<div v-html="this.$root.lessonData.description" class="descriptionBlock"></div>
									</div>
								</div>
							</div>
							<div class="wrapper">
								<button v-if="hasDocuments" class="accordion" @click="activetab = 2" :class="{ active: activetab === 2 }">{{ $t("lesson.tab.documents") }}</button>
								<div v-if="hasDocuments" class="panel">
									<v-divider />
									<div class="content">
										<Documents :documents="this.$root.lessonData.documents" />
									</div>
								</div>
							</div>
							<div class="wrapper">
								<button v-if="hasChapters" class="accordion" @click="activetab = 3" :class="{ active: activetab === 3 }">{{ $t("lesson.tab.chapters") }}</button>
								<div v-if="hasChapters" class="panel">
									<v-divider />
									<div class="content">
										<Chapters :showInTab="true" :videoPosition="this.currentVideoPosition" @select="onSelectChapter" />
									</div>
								</div>
							</div>
						</div>

						<div v-else class="tabsContainer">
							<div class="tabs">
								<h4>
									<a @click="activetab = 1" :class="{ active: activetab === 1 }">
										<span v-if="this.isVideoLesson">{{ $t('lesson.tab.description') }}</span>
										<span v-else>{{ lessonCategory }}</span>
									</a>
								</h4>
								<h4 v-if="hasDocuments">
									<a @click="activetab = 2" :class="{ active: activetab === 2 }">{{ $t("lesson.tab.documents") }}</a>
								</h4>
								<h4 v-if="hasChapters" class="hidden-md-and-up">
									<a @click="activetab = 3" :class="{ active: activetab === 3 }">{{ $t("lesson.tab.chapters") }}</a>
								</h4>
							</div>
							<v-divider />
							<div class="content">
								<div v-if="activetab === 1" v-html="this.$root.lessonData.description" class="descriptionBlock"></div>
								<div v-if="activetab === 2">
									<Documents :documents="this.$root.lessonData.documents" />
								</div>
								<div v-if="activetab === 3" class="hidden-md-and-up">
									<Chapters :showInTab="true" :videoPosition="this.currentVideoPosition" @select="onSelectChapter" />
								</div>
							</div>
						</div>

						<v-footer padless class="author">
							<span>{{ $t("lesson.author") }}</span>{{ this.$root.lessonData.author }}
						</v-footer>

					</v-card>
				</v-col>
				<v-col cols="12" md="4" class="hidden-sm-and-down">
					<Chapters :showInTab="false" :videoPosition="this.currentVideoPosition" @select="onSelectChapter" />
				</v-col>
			</v-row>

		</v-container>

	</MainLayout>

</template>

<script>
import Logger from '@/assets/scripts/logger.js'
import MainLayout from '@/layouts/Main'
//import VideoPlayer from '@/components/VideoPlayer'
import Chapters from '@/components/Chapters'
import Documents from '@/components/Documents'
import $ from 'jquery'

export default {
	name: 'Lesson',
	components: {
		MainLayout,
		// VideoPlayer,
		VideoPlayer: () => import('@/components/VideoPlayer'),
		Chapters,
		Documents
		// Chapters: () => import('@/components/Chapters'),
		// Documents: () => import('@/components/Documents')
	},
	metaInfo: {
		title: 'Lesson'
	},
	data() {
		return {
			activetab : 1,
			currentVideoPosition : NaN,
			isVideoLesson : this.$root.lessonData.isVideoLesson
		}
	},
	computed: {
		hasChapters() {
			return this.$root.lessonData.chapters != null;
		},
		hasDocuments() {
			return this.$root.lessonData.documents != null;
		},
		lessonCategory() {
			var category;
			if (this.$root.lessonData.category) {
				category = this.$root.lessonData.category[this.$i18n.locale] || this.$root.lessonData.category["en"];
			}
			return category || this.$t("lesson.tab.lesson");
		}
	},
	beforeCreate() {
		Logger.log("Lesson.vue beforeCreate");
	},
	created() {
		Logger.log("Lesson.vue created");
		$( window ).on("resize", this.onResize);
	},
	beforeMount() {
		Logger.log("Lesson.vue beforeMount");
	},
	mounted() {
		Logger.log("Lesson.vue mounted");

		// accordion control mobile devices
		$("button.accordion").on("click", function() {
			$("button.accordion").not(this).removeClass("open").next(":visible").hide();
			$(this).next().slideToggle("slow", function() {
				if ($(this).is(":visible")) {
					$(this).prev().addClass("open");
				}
				else {
					$(this).prev().removeClass("open");
				}
			});
		});
		$("button.accordion").first().addClass("open").next().show();
	},
	beforeUpdate() {
		Logger.log("Lesson.vue beforeUpdate");
	},
	updated() {
		Logger.log("Lesson.vue updated");
	},
	beforeDestroy() {
		Logger.log("Lesson.vue beforeDestroy");
		$( window ).off("resize", this.onResize);
	},
	destroyed() {
		Logger.log("Lesson.vue destroyed");
	},
	methods: {
		onResize() {
			// the chapter tab is only shown on smaller views
			// make sure it is not shown if the view is resized larger
			if (this.activetab === 3 && $( window ).width() > this.$vuetify.breakpoint.thresholds.sm) {
				this.activetab = 1;
			}
		},
		onSelectChapter(position) {
			if (this.isVideoLesson) {
				$("#divVideoPlayer").videoPlayer('jump2Position', position, true);
			}
			else {
				if (this.$root.device.mobile) {
					$("button.accordion").first().trigger("click");
					this.activetab = 1;
					this.$nextTick(function() {
						this.jumpToTextLessonPosition(position);
					});
				}
				else {
					if (this.activetab === 1)
						this.jumpToTextLessonPosition(position);
					else {
						this.activetab = 1;
						this.$nextTick(function() {
							this.jumpToTextLessonPosition(position);
						});
					}
				}
			}
		},
		onVideoChange(position) {
			this.currentVideoPosition = position;
		},
		jumpToTextLessonPosition(chapterNumber) {
			var id = "chapter_"+chapterNumber,
				headerHeight = $("header").innerHeight();
			$([document.documentElement, document.body]).animate({
				scrollTop: $("#"+id).offset().top - headerHeight
			}, 1000);
		}
	}
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';

	.tabsContainer {

		.tabs {
			padding: 1rem 2rem;

			h4 {
				display: inline-block;

				a {
					color: $globColSec;
					font-weight: normal;
					margin-right: 1.5rem;

					&.active {
						color: $globColPrim;
						font-weight: 600;
					}
				}
			}
		}

	}

	.content {
		font-size: 0.875rem;
		padding: 1rem 2rem;

		a {
			white-space: nowrap;
		}
	}

	.descriptionBlock {
		margin-bottom: 1rem;

		::v-deep a {
			color: $globColPrim;
			font-weight: 600;
			text-decoration: underline;
			white-space: nowrap;
		}
	}

	.author {
		@include skinColor(background-color, --skinColPrim, $skinColPrim);
		@include skinColor(color, --skinColPrimCompl, $skinColPrimCompl);
		height: 3rem;
		line-height: 3rem;
		overflow: hidden;
		padding: 0 2rem;
		text-overflow: ellipsis;
		white-space: nowrap;

		span {
			font-weight: bold;
			padding-right: 0.5rem;
		}
	}

	.accordion {
		position: relative;
		display: block;
		color: $globColSec;
		font-weight: normal;
		cursor: pointer;
		padding: 1rem 2rem;
		width: 100%;
		text-align: left;
		border: none;
		outline: none;

		&:after {
			content: '\25BC'; /* Unicode character for "black down-pointing triangle" */
			position: absolute;
			top: 1rem;
			right: 0.75rem;
			color: $globColSec;
			font-size: $fontSize14;
		}

		&.active, &.accordion:hover {
			color: $globColPrim;
			font-weight: 600;
		}

		&.open:after {
			content: "\25B2"; /* Unicode character for "black up-pointing triangle" */
		}
	}

	.panel {
		display: none;
		overflow: hidden;
	}

	.wrapper {
		border: 1px solid $globColTert;
		@include borderRadius(0.5rem);
	}

</style>
